var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0264 32.788L43.5357 81.9183L54.0784 77.1497L37.5142 16.9197L30.0264 32.788Z",
    fill: "#4C5A81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6992 56.7931L27.5909 89.1308L38.1316 84.3629L26.1875 40.9243L18.6992 56.7931Z",
    fill: "#838EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2539 15.6923L59.4833 74.7051L84.0204 63.6064C85.862 62.7734 86.3281 60.362 84.9219 58.9036L43.2539 15.6923Z",
    fill: "#445174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.283292 95.8184C-0.634648 97.7635 0.791284 99.9984 2.9334 99.9984C3.3412 99.9984 3.75232 99.9132 4.14001 99.738L22.1859 91.5756L14.8592 64.9296L0.283292 95.8184Z",
    fill: "#C8CCD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2931 17.9279L56.7553 19.0037C56.0317 20.4509 56.6182 22.2104 58.0654 22.934C59.5153 23.659 61.2737 23.0682 61.9957 21.6239L62.5336 20.5484C65.5767 14.4628 65.3411 7.32377 61.9039 1.45169C61.0864 0.0552457 59.2917 -0.41388 57.8957 0.403282C56.4994 1.22064 56.0301 3.01511 56.8475 4.41155C59.2802 8.56768 59.447 13.6204 57.2931 17.9279Z",
    fill: "#AF8EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5503 38.0972C92.6782 34.66 85.5396 34.4241 79.4536 37.4673L78.3779 38.0052C76.9307 38.7288 76.3442 40.4885 77.0678 41.9355C77.581 42.9623 78.6156 43.5556 79.6903 43.5556C80.5366 43.5556 80.9878 43.2509 82.0739 42.7078C86.3815 40.554 91.4343 40.7207 95.5902 43.1537C96.9865 43.9706 98.7812 43.5019 99.5985 42.1053C100.416 40.709 99.9467 38.9145 98.5503 38.0972Z",
    fill: "#AF8EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0698 0.00195312C95.4519 0.00195312 94.1402 1.31363 94.1402 2.93155V3.12686C94.1402 4.95766 92.6508 6.44706 90.82 6.44706C85.2645 6.44706 81.4453 10.7932 81.4453 15.6265C81.4453 17.2444 82.757 18.5561 84.3749 18.5561C85.9928 18.5561 87.3045 17.2444 87.3045 15.6265C87.3045 13.7957 88.7939 12.3063 90.6247 12.3063C95.8792 12.3063 99.9994 8.33978 99.9994 2.93155C99.9994 1.31363 98.6877 0.00195312 97.0698 0.00195312Z",
    fill: "#AF8EFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0039 10.744C76.6221 10.744 77.9336 9.43224 77.9336 7.81427C77.9336 6.1963 76.6221 4.88458 75.0039 4.88458C73.3695 4.88458 72.0732 6.20997 72.0732 7.81427C72.0734 9.43224 73.3859 10.744 75.0039 10.744Z",
    fill: "#AF8EFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8799 31.0557C73.498 31.0557 74.8096 29.7439 74.8096 28.126C74.8096 26.508 73.498 25.1963 71.8799 25.1963C70.2455 25.1963 68.9492 26.5217 68.9492 28.126C68.9494 29.7441 70.2619 31.0557 71.8799 31.0557Z",
    fill: "#AF8EFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1211 25.001C95.1211 23.3962 93.8232 22.0714 92.1895 22.0714C90.5715 22.0714 89.2607 23.3831 89.2607 25.001C89.2607 26.619 90.5734 27.9307 92.1914 27.9307C93.8096 27.9307 95.1211 26.6192 95.1211 25.001Z",
    fill: "#AF8EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.27c4fa1eb9446345eab7017a40f40773.svg";
export { ForwardRef as ReactComponent };